import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "magic-link-landing" }
const _hoisted_2 = { class: "app-branding" }
const _hoisted_3 = ["src"]

import { useRoute } from "vue-router";
import { useRouter } from "vue-router";

import RoundedButton from "../components/RoundedButton.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MagicLink',
  setup(__props) {

const LogoFlat = require("../assets/logo/icon-flat.svg") as string;

const route = useRoute();
const router = useRouter();

function openDesktopApp() {
  window.location.href =
    "messenger-pigeon://auth/magic-link/" + route.params.uuid;
}

function openWebApp() {
  router.push('/magic-link-login/' + route.params.uuid)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(LogoFlat),
        class: "logo"
      }, null, 8, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "mp-title" }, "Messenger Pigeon", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "By Habitat Learn", -1))
    ]),
    _createVNode(RoundedButton, {
      class: "magic-link-button",
      text: "OPEN DESKTOP APPLICATION",
      uppercase: "",
      taller: "",
      accent: "",
      lessRound: "",
      monospace: "",
      semiBold: "",
      type: "submit",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openDesktopApp())),
      enterPress: () => openDesktopApp(),
      ariaLabel: "Open Desktop Application"
    }, null, 8, ["enterPress"]),
    _createVNode(RoundedButton, {
      class: "magic-link-button",
      text: "OPEN WEB APPLICATION",
      uppercase: "",
      taller: "",
      accent: "",
      lessRound: "",
      monospace: "",
      semiBold: "",
      type: "submit",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (openWebApp())),
      enterPress: () => openWebApp(),
      ariaLabel: "Open Web Application"
    }, null, 8, ["enterPress"])
  ]))
}
}

})